module.exports = __webpack_public_path__ + "img/ears-05.283d272c.svg";